import React from "react";

function Undertaking() {
  return (
    <html xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <title></title>
      </head>
      <body>
        <table
          width="850"
          border="0"
          align="center"
          cellpadding="0"
          cellspacing="0"
        >
          <tr style={{ textAlign: "center" }}>
            <td
              colspan="3"
              style={{
                fontFamily: "Tahoma, Geneva, sans-serif",
                fontSize: "1.7em",
                color: "#000",
                textDecoration: "underline",
                fontWeight: "bold",
                padding: "100px 0 0px 0",
                letterSpacing: ".03em",
              }}
            >
              UNDERTAKING
            </td>
          </tr>
          <tr>
            <td
              width="490"
              valign="top"
              style={{
                fontFamily: "Arial, Helvetica, sans-serif",
                lineHeight: "25px",
                textAlign: "justify",
              }}
            >
              <p style={{ marginTop: "20px" }}>
                We, __________ Limited, a public/private limited company,
                incorporation certificate number _________, registered/head
                office at _____________________________________, hereby
                undertake and confirm that our shipments being stored and/or
                forwarded through TCS, either regularly or occasionally, are
                lawful and do not contain any contraband, explosives,
                commodities/goods fall under dangerous goods or any kind of
                prohibited material according to the Laws of Islam Republic of
                Pakistan.
                <br />
                <br /> We also undertake and confirm that all the government
                levies, taxes and duties of the shipments/goods being stored
                and/or forwarded through TCS have been paid in full and we
                undertake to provide all legal valid documents, including but
                not limited to Invoices, Bill of Entry/Lading (in case of
                imported goods) etc, pertaining to the said shipments/goods
                whenever required by competent authorities or TCS on behalf of
                the said authorities. In case of any incident involving legal
                proceedings including inspection, confiscation or detention of
                goods, taken by the Government Authority(ies), we shall take
                full responsibility for the same and deal directly with the said
                Authority(ies) to comply with all the legal and procedural
                requirements of the said authority(ies).
                <br />
                <br /> We hereby confirm that TCS is not responsible to verify
                or check the relevant documents of the goods in doing this
                business with us.TCS will also have no legal or financial
                responsibility in such cases at any given time to get such
                seized/detained or confiscated goods released. We acknowledge
                that the role of TCS as a service provider is limited to the
                storing of our shipments/goods at designated warehouses and
                delivering the same at different places as per our
                request/advice. We, therefore, indemnify TCS from any
                inconvenience, damage, cost, expense (including attorney’s fee)
                fines, penalties, liabilities, claims or loss of goodwill and
                reputation suffered by TCS or any of its directors, officers or
                employees due to our incorrect /untrue representation hereunder
                or and violation of laws and rules or due to initiation of
                abovementioned legal proceedings, if any.
              </p>
            </td>
            <td width="20" valign="top">
              &nbsp;
            </td>
          </tr>
        </table>
        <table
          width="850"
          border="0"
          align="center"
          cellpadding="0"
          cellspacing="0"
        >
          <tr>
            <td
              style={{
                fontFamily: "Arial, Helvetica, sans-serif",
                paddingTop: "160px",
                fontSize: "16px",
                fontWeight: "normal",
                textAlign: "justify",
                paddingBottom: "20px",
              }}
            >
              Signature: <br />
              <br />
              <br />
              ____________________________
            </td>
          </tr>
        </table>
      </body>
    </html>
  );
}

export default Undertaking;
